/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import changePasswordTemplate from './change-password.tpl.html';
import FileSaver from 'file-saver';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function ProfileController(userService, unitService, $scope, $document, $mdDialog, $filter, $translate, agTypes, types, toast) {
    var vm = this;

    vm.agTypes = agTypes;
    vm.types = types;
    vm.platformVersion = THINGSBOARD_VERSION; //eslint-disable-line
    vm.platformGitRef = TB_GIT_REF; //eslint-disable-line
    vm.profileUser = {};
    vm.save = save;
    vm.changePassword = changePassword;

    vm.generateReportNow = generateReportNow;
    vm.generateAndDownloadReportNow = generateAndDownloadReportNow;
    vm.scheduleEnableChanged = scheduleEnableChanged;

    vm.languageList = (["en_US", "no_NO", "ru_RU", "sv_SE", "es_ES", "bg_BG", "tr_TR", "pt_PT", "pl_PL", "de_DE"]);

    loadProfile();

    function loadProfile() {
        userService.getUser(userService.getCurrentUser().userId).then(function success(user) {
            vm.profileUser = user;
            if (!vm.profileUser.additionalInfo) {
                vm.profileUser.additionalInfo = {};
            }
            if (!vm.profileUser.additionalInfo.lang) {
                vm.profileUser.additionalInfo.lang = $translate.use();
            }
            if (!vm.profileUser.additionalInfo.temperatureUnit) {
                vm.profileUser.additionalInfo.temperatureUnit = unitService.getTemperatureUnit();
            }
            if (!vm.profileUser.additionalInfo.reportConfig) {
                vm.profileUser.additionalInfo.reportConfig = {};
            }
            if (!vm.profileUser.additionalInfo.reportConfig.schedule) {
                vm.profileUser.additionalInfo.reportConfig.schedule = {
                    enable: false
                };
            }
            if (vm.profileUser.additionalInfo.reportConfig.lastGeneratedTime) {
                vm.lastReportGeneratedTime = $filter('date')(vm.profileUser.additionalInfo.reportConfig.lastGeneratedTime, 'yyyy-MM-dd HH:mm:ss');
            }
            if (vm.profileUser.additionalInfo.reportConfig.schedule.enable) {
                setScheduleTime(vm.profileUser.additionalInfo.reportConfig.schedule.scheduleTime);
            }
            if (!vm.profileUser.additionalInfo.notificationEmail) {
                vm.profileUser.additionalInfo.notificationEmail = user.email;
            }
            $scope.theForm.$setPristine();
        });
    }

    function save() {
        if (vm.profileUser.additionalInfo.reportConfig.schedule.enable) {
            vm.profileUser.additionalInfo.reportConfig.schedule.scheduleTime = getScheduleTime();
        }
        userService.getUser(userService.getCurrentUser().userId).then(function success(user) {
            mergeReportConfig(user);
            userService.saveUser(vm.profileUser).then(function success(user) {
                $translate.use(vm.profileUser.additionalInfo.lang);
                unitService.updateTemperatureUnit(vm.profileUser.additionalInfo.temperatureUnit);
                vm.profileUser = user;
                $scope.theForm.$setPristine();
            });
        });
    }

    function mergeReportConfig(user) {
        if (user.additionalInfo && user.additionalInfo.reportConfig) {
            var reportConfig = vm.profileUser.additionalInfo.reportConfig;
            vm.profileUser.additionalInfo.reportConfig = user.additionalInfo.reportConfig;
            vm.profileUser.additionalInfo.reportConfig.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; //eslint-disable-line
            vm.profileUser.additionalInfo.reportConfig.siteIds = reportConfig.siteIds;
            vm.profileUser.additionalInfo.reportConfig.includeSensorsData = reportConfig.includeSensorsData;
            vm.profileUser.additionalInfo.reportConfig.schedule = reportConfig.schedule;
        }
    }

    function generateReportNow() {
        userService.getUser(userService.getCurrentUser().userId).then(function success(user) {
            if (!user.additionalInfo) {
                user.additionalInfo = {};
            }
            if (!user.additionalInfo.reportConfig) {
                user.additionalInfo.reportConfig = {};
            }
            user.additionalInfo.reportConfig.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; //eslint-disable-line
            user.additionalInfo.reportConfig.generateNow = true;
            userService.saveUser(user).then(function success() {
                toast.showSuccess($translate.instant('profile.report-generation-scheduled-message'));
            });
        });
    }

    function generateAndDownloadReportNow() {
        userService.getUser(userService.getCurrentUser().userId).then(function success(user) {
            if (!user.additionalInfo) {
                user.additionalInfo = {};
            }
            if (!user.additionalInfo.reportConfig) {
                user.additionalInfo.reportConfig = {};
            }
            user.additionalInfo.reportConfig.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; //eslint-disable-line
            user.additionalInfo.reportConfig.generateNow = true;
            userService.saveUser(user).then(function success() {
                userService.downloadReport(user.id.id).then(function success(response) {
                    FileSaver.saveAs(response.data, 'Agrolog Report.xlsx');
                });
            });
        });
    }

    function scheduleEnableChanged() {
        if (vm.profileUser.additionalInfo.reportConfig.schedule.enable) {
            var schedule = vm.profileUser.additionalInfo.reportConfig.schedule;
            if (!schedule.scheduleTime) {
                schedule.scheduleTime = {
                    hours: 12,
                    minutes: 0
                };
            }
            if (angular.isUndefined(schedule.type)) {
                schedule.type = 0;
            }
            if (!schedule.dayOfWeek) {
                schedule.dayOfWeek = vm.types.dayOfWeek.MON.value;
            }
            setScheduleTime(schedule.scheduleTime);
        }
    }

    function setScheduleTime(scheduleTime) {
        vm.scheduleTime = new Date(
            0,
            0,
            0,
            scheduleTime.hours,
            scheduleTime.minutes
        );
    }

    function getScheduleTime() {
        if (vm.scheduleTime) {
            return {
                hours: vm.scheduleTime.getHours(),
                minutes: vm.scheduleTime.getMinutes()
            }
        } else {
            return {
                hours: 12,
                minutes: 0
            }
        }
    }

    function changePassword($event) {
        $mdDialog.show({
            controller: 'ChangePasswordController',
            controllerAs: 'vm',
            templateUrl: changePasswordTemplate,
            parent: angular.element($document[0].body),
            fullscreen: true,
            targetEvent: $event
        }).then(function () {
        }, function () {
        });
    }
}
